import React, { useEffect } from "react";
import CloseIcon from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import FullScreenPopup from "app/common/Component/Popup/FullScreenPopup";
import NoImage from "app/common/Image/NoImage.jpg";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getFileDescription } from "app/services/PublicService";
import { CheckBox, CheckBoxOutlineBlank, Create } from "@material-ui/icons";
import { IconButton, Tooltip } from "@material-ui/core";
import { getLastName } from "./LocalFunction";
import { getFileById } from "app/services/FileDescriptionExtService";

export default function ViewImageAvatar({
  fileDescriptionId,
  handleClearImage,
  disabled,
  width,
  widthImg,
  maxWidthImg,
  height,
  heightImg,
  maxHeightImg,
  isImage = false,
  publicLink = false,
  imgUrl,
  isSelect,
  listSelected,
  setListSelected,
  onChange,
  handleEdit,
  name,
}) {
  const { t } = useTranslation();
  const [image, setImage] = React.useState(false);

  const [openConfirmPopup, setOpenConfirmPopup] = React.useState(false);
  const [openFullScreenPicture, setOpenFullScreenPicture] =
    React.useState(false);

  React.useEffect(() => {
    if (!imgUrl) {
      if (fileDescriptionId && !publicLink) {
        getFileById(fileDescriptionId)
          .then(({ data }) => {
            setImage(URL.createObjectURL(data));
          })
          .catch((error) => {
            console.error(error);
            toast.error("Lấy hình ảnh có lỗi");
          });
      } else if (publicLink) {
        getFileDescription(fileDescriptionId)
          .then(({ data }) => {
            setImage(URL.createObjectURL(data));
          })
          .catch((error) => {
            console.error(error);
            toast.error("Lấy hình ảnh có lỗi");
          });
      } else if (!fileDescriptionId) {
        setImage(false);
      }
    }
  }, [fileDescriptionId]);

  useEffect(() => {
    setImage(imgUrl);
  }, [imgUrl]);

  return (
    <>
      <div
        className={`${
          heightImg || maxHeightImg ? "" : "h-100"
        } flex-center flex-column position-relative`}
        style={{ width: width || "auto", height: height || "auto" }}
      >
        <p
          onClick={() => {
            if (onChange) onChange();
          }}
          className={`flex-grow-1 max-width-100  avatar-new ${
            heightImg || maxHeightImg ? "" : "max-height-320"
          }`}
          style={{
            ...(heightImg ? { height: heightImg } : {}),
            ...(maxHeightImg ? { maxHeight: maxHeightImg } : {}),
            ...(widthImg ? { width: widthImg } : {}),
            ...(maxWidthImg ? { maxWidth: maxWidthImg } : {}),
            backgroundColor: "#5899ca7d",
          }}
        >
          {image ? (
            <>
              <img
                src={image}
                alt="Chưa có ảnh"
                className={` avatar-new ${
                  widthImg || maxWidthImg ? "" : "max-width-100"
                } ${heightImg || maxHeightImg ? "" : "max-height-100"}`}
                style={{
                  ...(heightImg ? { height: heightImg } : {}),
                  ...(maxHeightImg ? { maxHeight: maxHeightImg } : {}),
                  ...(widthImg ? { width: widthImg } : {}),
                  ...(maxWidthImg ? { maxWidth: maxWidthImg } : {}),
                  objectFit: "cover",
                }}
              />
            </>
          ) : (
            <>
              <div className={` `}>{name ? getLastName(name) : "NS"}</div>
            </>
          )}
        </p>

        {!isImage && image && (
          <div
            className="topImgContainer flex-wrap gap-1"
            style={{ zIndex: "10", marginTop: 0, marginRight: 0 }}
          >
            {!disabled && (
              <Tooltip title="Xóa hình ảnh">
                <IconButton
                  size="small"
                  className="actionButton"
                  onClick={() => setOpenConfirmPopup(true)}
                >
                  <CloseIcon className="actionIcon" />
                </IconButton>
              </Tooltip>
            )}

            {isSelect && (
              <Tooltip title="Chọn hình ảnh">
                <IconButton
                  size="small"
                  className="actionButton"
                  onClick={() => {
                    if (listSelected?.find((it) => it === image)) {
                      setListSelected(
                        listSelected?.filter((it) => it !== image)
                      );
                    } else {
                      setListSelected([...listSelected, image]);
                    }
                  }}
                  disabled={disabled}
                >
                  {listSelected?.find((it) => it === image) ? (
                    <CheckBox
                      style={{ color: "#fff" }}
                      className="actionIcon"
                    />
                  ) : (
                    <CheckBoxOutlineBlank className="actionIcon" />
                  )}
                </IconButton>
              </Tooltip>
            )}
          </div>
        )}
      </div>

      {openConfirmPopup && (
        <ConfirmPopup
          open={openConfirmPopup}
          onClose={() => setOpenConfirmPopup(false)}
          text={t("Bạn có chắc muốn xóa hình ảnh này?")}
          onConfirm={() => {
            handleClearImage();
            setOpenConfirmPopup(false);
          }}
          isNotAPromise
        />
      )}

      {openFullScreenPicture && (
        <FullScreenPopup
          fullScreenPicture
          open={openFullScreenPicture}
          handleClose={() => setOpenFullScreenPicture(false)}
        >
          <div className="h-100 flex-center flex-column position-relative">
            <img
              src={image}
              alt="Chưa có ảnh"
              style={{ width: "100%", maxHeight: "90vh", objectFit: "contain" }}
            />
          </div>
        </FullScreenPopup>
      )}
    </>
  );
}
